import { InjectionToken } from '@angular/core';
import { MojoTasksService } from 'mojo-tasks';

export const TASKS_SERVICE = new InjectionToken<MojoTasksService>('MojoTasksService');
